import AngularResource from 'angular-resource';
import alertService from '@jetbrains/ring-ui/components/alert-service/alert-service';
import FIELDS from './resource__fields';
import InstallerAuth from '../app/app.auth';

const PING_TIMEOUT = 5000;
const ALERT_DISPLAY = 10000;

export default angular.module('installer.resource', [AngularResource, 'installer.config', InstallerAuth.name]).

  constant('fields', FIELDS).

  factory('backendAvailabilityInterceptor', $q => ({
    responseError(rejection) {
      if (rejection.status === -1 && !rejection.config.__wizardDoNotInterceptOnError) {
        alertService.error(`Could not connect to ${rejection.config.url}. Please check your network and server status.`, ALERT_DISPLAY);
      }
      if (rejection.status === 500) {
        alertService.error('Internal server error. Check serverside logs for details.');
      }
      return $q.reject(rejection);
    }
  })).

  config($httpProvider => {
    $httpProvider.interceptors.push('backendAvailabilityInterceptor');
    $httpProvider.interceptors.push('authInterceptor');
  }).

  factory('installerResource', ($resource, installerConfig) => {
    const backendUrl = installerConfig.backend.url;
    const bundleRootURL = installerConfig.backend.bundleRootURL;
    const resourceInstances = {};

    return {
      upgradeSource: $resource(`${backendUrl }/wizard/upgrade-source`, {}),
      upgradeSourceDefault: $resource(`${backendUrl }/wizard/upgrade-source/default`, {}),
      checkUpgradeSourcePath: $resource(`${backendUrl }/wizard/upgrade-source/check`, {}),

      upgradeSettings: $resource(`${backendUrl }/wizard/upgrade-settings`, {}),
      upgradeSettingsCandidate: $resource(`${backendUrl }/wizard/upgrade-settings/candidate`, {}),
      upgradeSettingsDefault: $resource(`${backendUrl }/wizard/upgrade-settings/default`, {}),
      checkUpgradeSettingsPath: $resource(`${backendUrl }/wizard/upgrade-settings/check`, {}),
      upgradeSourceClean: $resource(`${backendUrl }/wizard/upgrade-source/clean?backup=:backup`, {backup: '@backup'}),

      baseSettings: $resource(`${backendUrl }/wizard/basic-settings`, {}),
      baseSettingsDefault: $resource(`${backendUrl }/wizard/basic-settings/default`, {}),
      checkInstallPath: $resource(`${backendUrl }/wizard/basic-settings/check`, {}),

      hubSettings: $resource(`${backendUrl }/wizard/hub-settings`, {}),
      hubSettingsDefault: $resource(`${backendUrl }/wizard/hub-settings/default`, {}),
      hubCertificateUpload: $resource(`${backendUrl }/wizard/certificates`, {}),

      licenseSettings: $resource(`${backendUrl }/wizard/license-key`, {}),
      licenseSettingsDefault: $resource(`${backendUrl }/wizard/license-key/default`, {}),
      licenseSettingsDefaultsForUpgrade: $resource(`${backendUrl }/wizard/license-key/upgrade/default`, {}),

      connections: $resource(`${backendUrl }/wizard/connections/:id`, {}),

      cert: $resource(`${backendUrl }/wizard/cert/`, {}),

      licenseAgreements: $resource(`${backendUrl }/license-agreements`),

      browse: $resource(`${backendUrl }/browse`, {}),

      steps: $resource(`${backendUrl }/wizard/steps`, {}),

      bundleService: $resource(`${backendUrl }/hub/bundle-service`, {}),
      urlAfterCompletion: $resource(`${backendUrl }/wizard/wait/url`, {}),
      dump: $resource(`${backendUrl }/wizard/wait/dump`, {}, {
        save: {
          method: 'POST',
          __wizardDoNotInterceptOnError: true
        }
      }),
      waitPing: $resource(`${backendUrl }/wizard/wait/ping`, {}, {
        get: {
          timeout: PING_TIMEOUT,
          __wizardDoNotInterceptOnError: true
        }
      }),
      bundleInstallationState: $resource(`${bundleRootURL}bundle/backend/api/state`, {}, {
        get: {
          timeout: PING_TIMEOUT,
          __wizardDoNotInterceptOnError: true
        }
      }),

      /**
       * Returns singleton instance of resource. Usable to store form values in resource between wizard steps
       * @param resourceName - name of resource in installerResource
       * @returns {Object} resourceInstance
       */
      getSingletonOf(resourceName) {
        if (!resourceInstances[resourceName]) {
          resourceInstances[resourceName] = this[resourceName].get();
        }

        return resourceInstances[resourceName];
      },
      clearSingletonOf(resourceName) {
        delete resourceInstances[resourceName];
      },
      getArraySingletonOf(resourceName) {
        if (!resourceInstances[resourceName]) {
          resourceInstances[resourceName] = this[resourceName].query();
        }

        return resourceInstances[resourceName];
      },

      extractErrorMessage(errorResponse) {
        if (errorResponse && errorResponse.errors) {
          return (errorResponse.errors || []).reduce((hash, error) => {
            hash[error.error_field] = error;
            return hash;
          }, {originalResponse: errorResponse});
        }
        return errorResponse.message || errorResponse;
      }
    };
  }).

  factory('hubResource', $resource => (hubUrl, resource, accessToken) => $resource(`${hubUrl }/api/rest/${ resource }/:id`, null, {
    authorizedGet: {
      method: 'GET',
      headers: {Authorization: `Bearer ${ accessToken}`}
    },
    authorizedUpdate: {
      method: 'POST',
      headers: {Authorization: `Bearer ${ accessToken}`}
    }
  }));



// WEBPACK FOOTER //
// ./src/blocks/resource/resource.js